module.exports = __webpack_public_path__ + "img/activate-180.75f04ff.svg";